import React from "react";
import { useTranslation } from "react-i18next";
import { useRootAppStore } from "@hooks";
import { useFixBody } from "@state/hooks/shared";

export default function AutomaticLogoutPopupTemplate(props: {
	isOpened?: boolean;
}) {
	const { t } = useTranslation();
	const rootStore = useRootAppStore();

	const logout = async () => {
		rootStore.stopSession();
	};

	useFixBody(true, props.isOpened);

	return (
		<div className="popup">
			<div className="popup__card popup__card--med">
				<div className="popup__header">
					{t("SESSION.AUTO_LOGOUT.TITLE")}
				</div>
				<div className="popup__body">
					<div>{t("SESSION.AUTO_LOGOUT.LOGOUT_MESSAGE")}</div>
				</div>
				<div className="popup__footer">
					<button
						className="popup__btn btn btn--med btn--accent"
						type="button"
						onClick={logout}
					>
						{t("SESSION.AUTO_LOGOUT.BUTTON_OK")}
					</button>
				</div>
			</div>
		</div>
	);
}
